module.exports = __webpack_public_path__ + "static/media/americanas.d5deaf1b.svg";